import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-two-simple-view",
  templateUrl: "./axle-two-simple-view.component.html",
  styleUrls: ["./axle-two-simple-view.component.scss"],
})
export class AxleTwoSimpleViewComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() veiculoId: number;

  public sensorTwoLeftSelect: any = [];
  public sensorTwoRightSelect: any = [];

  public sensorTwoRightCombo: any = [];
  public sensorTwoLeftCombo: any = [];

  public axisTwoSimpleLeftForm: FormGroup;
  public axisTwoSimpleRightForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.axisTwoSimpleLeftForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisTwoSimpleRightForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisTwoSimpleLeftForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 2 ESQ"
      );
      this.axisTwoSimpleRightForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 2 DIR"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo2Direito = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          38
        );
        const eixo2Esquerdo = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          37
        );

        // EIXO 2 DIREITO
        if (eixo2Direito != null) {
          this.axisTwoSimpleRightForm.controls["id"].setValue(eixo2Direito.id);

          if (eixo2Direito.sensor != null) {
            appendSensorToCombo(this.sensorTwoRightCombo, eixo2Direito.sensor);
            this.sensorTwoRightSelect = eixo2Direito.sensor.id;
          }

          if (eixo2Direito.pneu != null) {
            this.axisTwoSimpleRightForm.controls["pneu"].setValue(
              eixo2Direito.pneu.numeroFogo
            );
          }

          this.axisTwoSimpleRightForm.controls["nrPressaoMinima"].setValue(
            eixo2Direito.nrPressaoMinima
          );

          this.axisTwoSimpleRightForm.controls["nrPressaoMaxima"].setValue(
            eixo2Direito[0].nrPressaoMaxima
          );

          this.axisTwoSimpleRightForm.controls["nrTemperaturaMaxima"].setValue(
            eixo2Direito[0].nrTemperaturaMaxima
          );
        }

        // EIXO 2 ESQUERDO
        if (eixo2Esquerdo != null) {
          this.axisTwoSimpleLeftForm.controls["id"].setValue(eixo2Esquerdo.id);

          if (eixo2Esquerdo.sensor != null) {
            appendSensorToCombo(this.sensorTwoLeftCombo, eixo2Esquerdo.sensor);
            this.sensorTwoLeftSelect = eixo2Esquerdo.sensor.id;
          }

          if (eixo2Esquerdo.pneu != null) {
            this.axisTwoSimpleLeftForm.controls["pneu"].setValue(
              eixo2Esquerdo.pneu.numeroFogo
            );
          }

          this.axisTwoSimpleLeftForm.controls["nrPressaoMinima"].setValue(
            eixo2Esquerdo.nrPressaoMinima
          );

          this.axisTwoSimpleLeftForm.controls["nrPressaoMaxima"].setValue(
            eixo2Esquerdo.nrPressaoMaxima
          );

          this.axisTwoSimpleLeftForm.controls["nrTemperaturaMaxima"].setValue(
            eixo2Esquerdo.nrTemperaturaMaxima
          );
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
